import type { PageProps } from 'gatsby';
import React from 'react';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';
import UserDrilldown from '@views/Admin/Management/Users/Drilldown';

export default function AdminUserDrilldownPage({ params }: PageProps) {
  const { id: user_id } = params;

  return (
    <AdminManagement.Layout maxContentWidth="md">
      <BigCircle />
      {user_id && <UserDrilldown user_id={user_id} />}
    </AdminManagement.Layout>
  );
}
